import type {ReactElement} from 'react';
import React from 'react';
import styles from './pulsating-dot.module.scss';

interface PulsatingDotProps {
  containerClassname: string;
  pulseColor?: string;
  dotColor?: string;
  showPulse?: boolean;
}

export function PulsatingDot({dotColor = 'bg-secondary-150', pulseColor = 'bg-secondary-50', showPulse = true, ...props}: PulsatingDotProps): ReactElement<any> {
  return (
    <div className={props.containerClassname}>
      <div className={`radius-round ${dotColor} ${styles.dot}`} />
      <div className={`radius-round ${pulseColor} ${showPulse ? styles.pulse : styles.pulseStatic}`} />
    </div>
  );
}
